import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;

export const getContractorDashboardService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/dashboard`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const GetLikesService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/likes/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const GetUpliftsService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/uplifts/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const GetFlaggedService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/flagged/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const GetActivityListService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/activity/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const getContractorFeedbackService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/contractor/feedback`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data;
	} catch (error) {
		console.error("Error in flagAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const GetCommentHistoryService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/comment-history/list`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};



export const GetReplies = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/replies/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in ActivityLogDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};